import React from 'react';
import Minus from 'src/assets/icons/minus.svg';
import Plus from 'src/assets/icons/plus.svg';
import Range from 'rc-slider/lib/Range';
import Label from 'src/components/_utility/Label';
import { Outer, Tooltip, Circle, Handle, HandleWrap } from './RangeSlider.styled';

const RangeSlider = ({ onDecreaseQuantity, onIncreaseQuantity, canDecrease, canIncrease, ...props }) => (
  <Outer>
    <Circle data-testid="rangeMin" disabled={!canDecrease} onClick={onDecreaseQuantity}>
      <Minus />
    </Circle>
    <Range
      marks={{ 20: 20, 40: 40, 100: 100 }}
      step={null}
      {...props}
      handle={handleProps => (
        <HandleWrap left={handleProps.offset}>
          <Handle role="slider" aria-valuemin={0} aria-valuemax={0} aria-valuenow={0} tabindex={0} {...handleProps} />
          <Tooltip>{handleProps.index === 0 ? <Label name="fromLabel" /> : <Label name="toLabel" />}</Tooltip>
        </HandleWrap>
      )}
    />
    <Circle data-testid="rangeMax" disabled={!canIncrease} onClick={onIncreaseQuantity}>
      <Plus />
    </Circle>
  </Outer>
);

export default RangeSlider;
